module.exports = __webpack_public_path__ + "static/media/remove.dc8a2982.png";